module.exports = __webpack_public_path__ + "assets/img/dzh-1.6356eae1.jpg";